
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class ApprovalOutItemsGrid extends Serenity.EntityGrid<ApprovalOutItemsRow, any> {
        protected getColumnsKey() { return 'Sales.ApprovalOutItems'; }
        protected getDialogType() { return ApprovalOutItemsDialog; }
        protected getIdProperty() { return ApprovalOutItemsRow.idProperty; }
        protected getInsertPermission() { return ApprovalOutItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalOutItemsRow.localTextPrefix; }
        protected getService() { return ApprovalOutItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true; 
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }

}